export const REMBOURSEMENTS = 1
export const COTISATIONS = 2

export const NATURE = {
	// Nature "Chèque" ou "Lettre chèque"
	CHEQUE: 1,
	// Nature "Virement" ou "Prélèvement"
	VIREMENT: 2
}
